import Router from '@app/router';
import Helpers from '@app/global/helpers';
import Store from '@app/store';
export default {
    /*
    * Updates page title and meta description
    */
    updateMedadata(route) {
        document.title = route.meta.title;
        let metaDescEl = document.querySelector('meta[name="description"]');
        if (!metaDescEl) {
            metaDescEl = document.createElement('meta');
            metaDescEl.setAttribute('name', 'description');
            document.head.insertBefore(metaDescEl, document.querySelector('meta[name="author"]'));
        }
        metaDescEl.setAttribute("content", route.meta.description);
        // Update Open Graph Tags
        this.setMetaTag('property="og:url"', `${window.location.protocol}//${window.location.host}${route.path}`);
        this.setMetaTag('property="og:title"', route.meta.title);
        this.setMetaTag('property="og:description"', route.meta.description);
    },
    /*
    * Function to convert a Evolve Route model to a Vue route
    */
    makeRoute(backendRoute) {
        let meta = {
            id: backendRoute.id,
            title: backendRoute.page_title,
            description: backendRoute.meta_description,
            isHome: backendRoute.path == window.HOME_ROUTE_PATH,
            type: backendRoute.controllerType,
            hasPageData: true,
        };
        let path = '/' + (backendRoute.path == '/' ? '' : backendRoute.path);
        let route = {
            name: meta.isHome ? 'home' : `page-${backendRoute.id}`,
            path: path,
            meta: meta,
            component: () => import(
            /* webpackChunkName: "Evolve-Controller-[request]" */
            `@app/modules/${backendRoute.controllerType}Controller.vue`),
            props: {
                getPage: () => Store.STATE.pageData[path]
            }
        };
        return route;
    },
    /*
    * Function for scrolling to an anchor
    */
    scrollToAnchor(anchor) {
        const el = document.querySelector(anchor);
        if (el) {
            Helpers.scrollTo(el);
        }
    },
    /**
     * Sets or updates the content property on a given meta tag
     *
     * @param tag Meta tag selector
     * @param content Meta content to set
     */
    setMetaTag(propertySelector, content) {
        const el = document.querySelector(`meta[${propertySelector}]`);
        if (el) {
            el.setAttribute('content', content);
        }
    },
    /**
     * Check if a given path can be matched to a router route
     * Excludes the 404 catch-all route
     *
     * @param path Path to check
     */
    routeExists(path) {
        const matched = Router.resolve(path).matched;
        return matched.length === 1
            && matched[0].name !== '404';
    },
    /**
     * Define final routes that will be added to the router at last
     */
    addFinalRoutes() {
        const redirects = window.REDIRECTS;
        if (redirects) {
            redirects.map(redirect => {
                return {
                    path: redirect.from,
                    redirect: redirect.to
                };
            }).forEach(route => {
                Router.addRoute(route);
            });
        }
        Router.addRoute({
            name: '404',
            path: '/:pathMatch(.*)*',
            component: () => import(/* webpackChunkName: "Evolve-PageNotFound" */ '@app/components/Errors/404.vue')
        });
    }
};
